import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { ONE_MINUTE } from 'utils/time';
import useBEFinSession from './useBEFinSession';
import { useIsBEFinFeatureEnabled } from 'utils/docsRepo/useIsBEFinFeatureEnabled/useIsBEFinFeatureEnabled';

const useBEFinSessionUI = (): {
  isSessionExpired: boolean;
} => {
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const isFeatureEnabled = useIsBEFinFeatureEnabled();
  const { sessionData } = useBEFinSession();

  // Check expiration based on cached expirationDate
  useEffect(() => {
    // Skip expiration check if feature not enabled
    if (!isFeatureEnabled || !sessionData) {
      setIsSessionExpired(false);
      return;
    }

    const checkExpiration = () => {
      const expirationDate = sessionData.expirationDate;
      const expiresIn = sessionData.expiresIn;
      const hasAnyConsent =
        sessionData?.consents &&
        Object.values(sessionData.consents).some(Boolean);

      // Check if current time is past expiration date
      const isExpired = expirationDate
        ? dayjs().isAfter(dayjs(expirationDate))
        : false;

      if (
        hasAnyConsent &&
        (isExpired || (expiresIn !== undefined && expiresIn <= 0))
      ) {
        setIsSessionExpired(true);
      } else {
        setIsSessionExpired(false);
      }
    };

    checkExpiration();

    const intervalId = setInterval(checkExpiration, ONE_MINUTE);

    return () => clearInterval(intervalId);
  }, [sessionData, isFeatureEnabled]);

  return { isSessionExpired };
};

export default useBEFinSessionUI;
